import { ItemizedResult } from "@/types/diagnostic";

export type ItemizedQuestion = {
  type: Type;
  questions: Question[];
};

type Question = {
  title: string;
  answers: Answer[];
};

type Answer = {
  title: string | number;
  score?: number;
};

type Type = "忙しさ";

export const ItemizedQuestions: ItemizedQuestion[] = [
  {
    type: "忙しさ",
    questions: [
      {
        title: "スケジュールに空きがあると不安になる",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "何事も自分が確認しないと気が済まない",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "1人で黙々と仕事するより人と話す方が好きだ",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "遠距離の顧客訪問も苦にならない",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "繰り返し業務があっても効率化していない",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "依頼されたもの以外でも何となくやってしまう",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "メールや電話の時間が多い",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "じっくり考える時間があまり無い",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "ITツールやAIツールなどに疎い",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "1日のスケジュールを当日把握している",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "自分以外に振れない仕事がある",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "探し物をする時間が多い",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "会議や打ち合わせの機会が多い",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "会議や打ち合わせの時間が長い",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "社外の集まりに顔をだす機会が多い",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "聞くより話す方が好きだ",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "話を端的にまとめて伝えることが苦手だ",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "業務時間外の電話に出ることがよくある",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "仕事で手戻りや確認に要する時間が多い",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
      {
        title: "プライベートの時間を事前に確保していない",
        answers: [
          {
            title: "当てはまる",
            score: 5,
          },
          {
            title: "やや当てはまる",
            score: 3,
          },
          {
            title: "少し当てはまる",
            score: 2,
          },
          {
            title: "当てはまらない",
            score: 0,
          },
        ],
      },
    ],
  },
];

export const ItemizedResults: ItemizedResult[] = [
  {
    heading: "「忙しい！」レベル",
    evaluations: [
      {
        description:
          "あなたは常に忙しさMAXで、事あるごとに「忙しい！」を連呼している働きバチです。忙しいのが良いことと捉えがちですが、それだと自身に負担がかかるばかりか、生産性の高い仕事にも力を割けなくなり、最終的に品質を大きく落としてしまう要因となります。このような事態を避けるため、まずは自身の仕事やスケジュールを見える化し、「自分がやらなくても良いこと」を特定してみましょう。今すぐに社内や外注など周りへ振ることができなくても、忙しさの原因を知ることで自分がやるべき事かどうかの判断がつくようになります。",
      },
      {
        description:
          "あなたは常に忙しさに追われているわけではありませんが、一歩間違えると仕事に忙殺されるおそれがあります。そのような事態を避けるためにも、日々の仕事やスケジュールをしっかりと見える化し、何をすればもっと仕事に余裕が出来るか考える時間を確保しましょう。特に業務連絡や確認、会議や打ち合わせなどは必要以上に時間を取られる傾向にあります。例えば会議であれば本当にその時間が必要なのか、事前共有の上で会議を行うことで時間を削減できないか、などの方法を考えると良いでしょう。",
      },
      {
        description:
          "あなたは比較的時間に余裕があり、うまく仕事をこなしていると言えそうです。時間の使い方で重要なのは「やらないことの明確化」と「やるべきことの時短化」です。やらなくても良いことを極力やらない、もしくは自動化・マニュアル化するなどし、それと同時にやるべきことの順序や方法を変えることで時短ができないかを考えてみましょう。ただし顧客対応だけは安易に時短化すると、売上や利益の減少につながる可能性もあるため注意が必要です。",
      },
      {
        description:
          "あなたは仕事やスケジュールの管理ができ、理想的な働き方ができている状態です。その調子で自身の忙しさレベルをコントロールし、生産性の高い仕事に取り組んでいきましょう。特にAIツールは今後活用の幅が広がることで、強力な効率化ツールとしての活用が期待できます。そのためには最低限の知識や使用経験が必要となりますので、普段からニュースなどに目を通す、AIツールに触れてみるなどしてみましょう。",
      },
    ],
    recommend: [
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
      {
        datail: [{ url: "", text: "" }],
      },
    ],
  },
];
